import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { message } from 'antd';
import cookieHelper from './cookieHelper';

// Configuration - Production Values
// const JWT_EXPIRY_TIME = 2 * 60 * 60 * 1000; // 2 hours in milliseconds
// COMMENTED OUT: Inactivity and proactive extend-session (staff facing issues). 401 extend-session in axiosConfig remains.
// const INACTIVITY_TIMEOUT = 20 * 60 * 1000; // 20 minutes in milliseconds
// const TOKEN_EXPIRY_WARNING = 15 * 60 * 1000; // 15 minutes before expiry
const KEY_LAST_ACTIVITY = 'last_activity_timestamp';
const KEY_TOKEN_EXPIRY = 'token_expiry_timestamp';
const KEY_AUTH_TOKEN = 'id_token';

// Modal instances (commented out - inactivity/expiry modals disabled)
// let inactivityModal = null;
// let expiryWarningModal = null;

/**
 * Session Manager for HIPAA-compliant token management
 * Inactivity timeout and proactive token-expiry modals disabled; extend on 401 is in axiosConfig.
 */
class SessionManager {
  constructor() {
    this.idleTimer = null;
    this.expiryTimer = null;
    this.isAuthenticated = false;
    this.isRedirecting = false; // Flag to prevent multiple redirects
  }

  /**
   * Initialize the session manager
   * @returns {boolean} True if user is authenticated
   */
  init() {
    const token = localStorage.getItem(KEY_AUTH_TOKEN);
    
    if (!token) {
      this.isAuthenticated = false;
      return false;
    }
    
    this.isAuthenticated = true;
    // COMMENTED OUT: Inactivity and proactive expiry (staff facing issues). 401 refresh in axiosConfig remains.
    // this.setupActivityTracking();
    // this.setupExpiryTracking();
    
    return true;
  }

  // ========== COMMENTED OUT: Inactivity & proactive extend-session (staff issues). 401 extend in axiosConfig stays. ==========
  // /**
  //  * Set up activity tracking for inactivity timeout
  //  */
  // setupActivityTracking() {
  //   this.updateLastActivity();
  //   const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];
  //   activityEvents.forEach(event => {
  //     document.addEventListener(event, () => this.updateLastActivity(), true);
  //   });
  //   this.startInactivityTimer();
  // }
  // updateLastActivity() {
  //   localStorage.setItem(KEY_LAST_ACTIVITY, Date.now().toString());
  // }
  // startInactivityTimer() {
  //   if (this.idleTimer) clearTimeout(this.idleTimer);
  //   this.idleTimer = setInterval(() => this.checkInactivity(), 60000);
  // }
  // checkInactivity() {
  //   const lastActivity = parseInt(localStorage.getItem(KEY_LAST_ACTIVITY) || '0');
  //   const timeSinceLastActivity = Date.now() - lastActivity;
  //   if (timeSinceLastActivity >= INACTIVITY_TIMEOUT) this.showInactivityWarning();
  // }
  // showInactivityWarning() {
  //   if (inactivityModal) inactivityModal.destroy();
  //   inactivityModal = Modal.confirm({
  //     title: 'Session Timeout Warning',
  //     icon: <ExclamationCircleOutlined />,
  //     content: 'Your session is about to expire due to inactivity. Would you like to continue?',
  //     okText: 'Continue Session',
  //     cancelText: 'Log Out',
  //     onOk: () => this.extendSession(),
  //     onCancel: () => this.endSession(),
  //     centered: true,
  //     closable: false,
  //     maskClosable: false,
  //   });
  // }
  // setupExpiryTracking() {
  //   const token = localStorage.getItem(KEY_AUTH_TOKEN);
  //   if (!token) return;
  //   const loginTime = Date.now();
  //   const expiryTime = loginTime + JWT_EXPIRY_TIME;
  //   localStorage.setItem(KEY_TOKEN_EXPIRY, expiryTime.toString());
  //   this.startExpiryTimer();
  // }
  // startExpiryTimer() {
  //   if (this.expiryTimer) clearTimeout(this.expiryTimer);
  //   const expiryTime = parseInt(localStorage.getItem(KEY_TOKEN_EXPIRY) || '0');
  //   const now = Date.now();
  //   const timeUntilWarning = expiryTime - now - TOKEN_EXPIRY_WARNING;
  //   if (timeUntilWarning <= 0) { this.showExpiryWarning(); return; }
  //   this.expiryTimer = setTimeout(() => this.showExpiryWarning(), timeUntilWarning);
  // }
  // showExpiryWarning() {
  //   if (expiryWarningModal) expiryWarningModal.destroy();
  //   expiryWarningModal = Modal.confirm({
  //     title: 'Session Expiration Warning',
  //     icon: <ExclamationCircleOutlined />,
  //     content: 'Your session will expire in less than 15 minutes. Would you like to extend your session?',
  //     okText: 'Extend Session',
  //     cancelText: 'Log Out',
  //     onOk: () => this.extendSession(),
  //     onCancel: () => this.endSession(),
  //     centered: true,
  //     closable: false,
  //     maskClosable: false,
  //   });
  // }
  // extendSession() {
  //   try {
  //     const staffId = this.getStaffIdFromToken();
  //     if (!staffId) { this.redirectToLogin('Invalid session data'); return; }
  //     this.callExtendSessionAPI(staffId)
  //       .then(response => {
  //         if (response && response.success && response.accessToken) {
  //           localStorage.setItem(KEY_AUTH_TOKEN, response.accessToken);
  //           this.updateLastActivity();
  //           this.setupExpiryTracking();
  //           message.success('Session extended successfully');
  //         } else this.redirectToLogin('Unable to extend session');
  //       })
  //       .catch(error => {
  //         console.error('Error extending session:', error);
  //         this.redirectToLogin('Session extension failed');
  //       });
  //   } catch (error) {
  //     console.error('Error in extendSession:', error);
  //     this.redirectToLogin('Session error');
  //   }
  // }
  // async callExtendSessionAPI(staffId) {
  //   try {
  //     const { apiPost } = await import('./apiHelper');
  //     const validateResponse = await apiPost('api/v1/validateStaffSession', { staffId });
  //     if (validateResponse && validateResponse.valid && validateResponse.refreshToken) {
  //       return await apiPost('api/v1/extendStaffSession', {
  //         staffId,
  //         refreshToken: validateResponse.refreshToken
  //       });
  //     }
  //     return { success: false, message: 'Invalid session' };
  //   } catch (error) {
  //     console.error('API error extending session:', error);
  //     return { success: false, message: 'API error' };
  //   }
  // }
  // ========== END COMMENTED OUT ==========

  /**
   * Get staff ID from the token
   * @returns {number|null} Staff ID or null if not found
   */
  getStaffIdFromToken() {
    try {
      const token = localStorage.getItem(KEY_AUTH_TOKEN);
      if (!token) return null;
      
      // Basic JWT parsing (middle part contains the payload)
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
          .join('')
      );
      
      const payload = JSON.parse(jsonPayload);
      return payload.staffId;
    } catch (error) {
      console.error('Error parsing token:', error);
      return null;
    }
  }

  /**
   * End the current session and redirect to login
   * @param {string} reason - Reason for session end (optional)
   */
  endSession() {
    try {
      // Call the logout API
      const staffId = this.getStaffIdFromToken();
      if (staffId) {
        this.callEndSessionAPI(staffId)
          .catch(error => console.error('Error ending session:', error))
          .finally(() => this.redirectToLogin('Session ended'));
      } else {
        this.redirectToLogin('Session ended');
      }
    } catch (error) {
      console.error('Error in endSession:', error);
      this.redirectToLogin('Session error');
    }
  }

  /**
   * Call the API to end the session
   * @param {number} staffId - Staff ID
   * @returns {Promise} API response
   */
  async callEndSessionAPI(staffId) {
    try {
      const { apiPost } = await import('./apiHelper');
      return await apiPost('api/v1/endStaffSession', { staffId });
    } catch (error) {
      console.error('API error ending session:', error);
      throw error;
    }
  }

  /**
   * Redirect to login page with reason message
   * @param {string} reason - Reason for redirection
   */
  redirectToLogin(reason = 'Session timed out') {
    // Prevent multiple simultaneous redirects
    if (this.isRedirecting) {
      return;
    }

    // Check if already on login page to prevent redirect loops
    const currentPath = window.location.pathname;
    if (currentPath === '/signin' || currentPath === '/signin/' || currentPath === '/') {
      // Already on login page, just clear the data
      localStorage.removeItem(KEY_AUTH_TOKEN);
      localStorage.removeItem('@token');
      localStorage.removeItem(KEY_LAST_ACTIVITY);
      localStorage.removeItem(KEY_TOKEN_EXPIRY);
      cookieHelper.clearToken();
      return;
    }

    this.isRedirecting = true;

    // Clear all session data — must include cookie and all localStorage token keys
    // to prevent stale tokens from being attached to subsequent login requests
    localStorage.removeItem(KEY_AUTH_TOKEN);
    localStorage.removeItem('@token');
    localStorage.removeItem(KEY_LAST_ACTIVITY);
    localStorage.removeItem(KEY_TOKEN_EXPIRY);
    cookieHelper.clearToken();
    
    // Clear Redux auth state if available
    try {
      const { store } = require('../../redux/store');
      store.dispatch({ type: 'LOGOUT' });
    } catch (e) {
      // Store not available, continue
    }
    
    // Set reason in sessionStorage for login page to display
    sessionStorage.setItem('session_timeout_reason', reason);
    
    // Redirect to login page with cache bypass
    window.location.href = '/signin?nocache=' + Date.now();
  }

  /**
   * Clean up timers (call on component unmount)
   */
  cleanup() {
    if (this.idleTimer) {
      clearTimeout(this.idleTimer);
      this.idleTimer = null;
    }
    if (this.expiryTimer) {
      clearTimeout(this.expiryTimer);
      this.expiryTimer = null;
    }
    // COMMENTED OUT: Inactivity/expiry modals disabled
    // if (inactivityModal) { inactivityModal.destroy(); inactivityModal = null; }
    // if (expiryWarningModal) { expiryWarningModal.destroy(); expiryWarningModal = null; }
  }
}

// Create singleton instance
const sessionManager = new SessionManager();

export default sessionManager; 